import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch } from "vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import { BuilderInterfaceWithHouseDesigns } from "@/types/BuilderInterface";
  import HouseFeatures from "@/components/builder/HouseFeatures.vue";
  import BuilderSliderButtons from "./BuilderSliderButtons.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import BuilderControlsButtons from "./BuilderControlsButtons.vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { redirectWithoutRouter } from "@/helpers/redirectWithoutRouter";
  import { useRouter } from "vue-router";
  import { LotInterface } from "@/types/LotInterface";
  interface Props {
    builders: string[];
    lot: LotInterface;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderDropdownAndActions',
  props: {
    builders: {},
    lot: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(680);

  const props = __props;

  const router = useRouter();

  const selectedBuilder = ref<BuilderInterfaceWithHouseDesigns | null>(null);

  const selectedHouseDesign = ref<HouseDesignInterface | null>(null);

  const onRequestQuote = () => {
    router.push(`/builder/estate/${props.lot.estateId}/lot/${props.lot._id}`);
    return;
  };

  const selectBuilder = (builder: BuilderInterfaceWithHouseDesigns) => {
    if (selectedBuilder.value?._id === builder._id) {
      return;
    }

    selectedBuilder.value = builder;
    selectedHouseDesign.value = builder.houses[0];
    setDefaultValues(builder);
  };

  const selectHouseDesign = (houseDesign: HouseDesignInterface) => {
    if (selectedHouseDesign.value?._id === houseDesign._id) {
      return;
    }

    selectedHouseDesign.value = houseDesign;
  };

  const setDefaultValues = (builder: BuilderInterfaceWithHouseDesigns) => {
    if (!builder) {
      return;
    }

    selectedBuilder.value = builder;
    selectedHouseDesign.value = builder.houses[0];
  };

  watch(
    () => props.builders,
    () => {
      setDefaultValues(
        props.builders[0] as unknown as BuilderInterfaceWithHouseDesigns
      );
    }
  );
  onMounted(() => {
    setDefaultValues(
      props.builders[0] as unknown as BuilderInterfaceWithHouseDesigns
    );
  });

const __returned__ = { isDesktop, props, router, selectedBuilder, selectedHouseDesign, onRequestQuote, selectBuilder, selectHouseDesign, setDefaultValues, ref, onMounted, watch, get HouseDesignInterface() { return HouseDesignInterface }, get BuilderInterfaceWithHouseDesigns() { return BuilderInterfaceWithHouseDesigns }, HouseFeatures, BuilderSliderButtons, get useIsDesktop() { return useIsDesktop }, BuilderControlsButtons, DropDown, get redirectWithoutRouter() { return redirectWithoutRouter }, get useRouter() { return useRouter }, get LotInterface() { return LotInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})